var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":_vm.act}},[_c('i',{staticClass:"icon-pencil"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }